<template>
  <div class="SignInView">
    <!-- Desktop Logo !-->
    <img
      :src="logo"
      class="SignInView__logo--primary"
    >
    <!-- Left Panel !-->
    <div
      :style="{backgroundImage: `url(${leftImage})`}"
      class="SignInView__left-side bg-color-secondary"
    >
      <div class="SignInView__left-side__background text-center color-white d-flex flex-column">
        <span class="SignInView__left-side__background__content m-s-b font-xl">{{ leftTitle }}</span>
        <span class="SignInView__left-side__background__content font-l">{{ leftSubtitle }} </span>
      </div>
    </div>
    <!-- Right Panel !-->
    <div class="SignInView__right-side">
      <MuiNotificationList />
      <!-- Responsive Logo !-->
      <div class="text-center full-width center">
        <img
          :src="logo"
          class="SignInView__logo--responsive"
        >
      </div>
      <!-- View -->
      <div class="SignInView__right-side__wrapper full-width">
        <slot />
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';

import { MuiNotificationList } from '@ubeeqo/motion-ui';

export default {
  name: 'SignInTemplateComponent',
  components: {
    MuiNotificationList,
  },
  props: {
    logoDesktop: {
      default: '',
      type: [String, Object],
    },
    logoMobile: {
      default: '',
      type: [String, Object],
    },
    leftImage: {
      default: '',
      type: [String, Object],
    },
    leftTitle: {
      default: '',
      type: String,
    },
    leftSubtitle: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      logo: '',
    };
  },
  mounted() {
    this.setupLogoOnResize(window.innerWidth);
    window.addEventListener('resize', this.onResizeEvent());
  },
  methods: {
    onResizeEvent() {
      return _.throttle(($event) => {
        this.setupLogoOnResize($event.target.innerWidth);
      }, 200);
    },
    setupLogoOnResize(size) {
      const logo = size >= 992
        ? this.$props.logoDesktop
        : this.$props.logoMobile;
      this.$data.logo = logo;
    },
  },
};
</script>
